

export default {
  locale: 'az',
  Pagination: {
    items_per_page: '/ səhifə',
    jump_to: 'Get',
    jump_to_confirm: 'təsdiqlə',
    page: '',
    prev_page: 'Əvvəlki Səhifə',
    next_page: 'Növbəti Səhifə',
    prev_5: 'Əvvəlki 5 Səhifə',
    next_5: 'Növbəti 5 Səhifə',
    prev_3: 'Əvvəlki 3 Səhifə',
    next_3: 'Növbəti 3 Səhifə',
    page_size: 'Page Size'
  },
  DatePicker: {
    lang: {
      placeholder: 'Tarix seçin',
      rangePlaceholder: ['Başlama tarixi', 'Bitmə tarixi'],
      locale: 'az_AZ',
      today: 'Bugün',
      now: 'İndi',
      backToToday: 'Bugünə qayıt',
      ok: 'Təsdiq',
      clear: 'Təmizlə',
      month: 'Ay',
      year: 'İl',
      timeSelect: 'vaxtı seç',
      dateSelect: 'tarixi seç',
      weekSelect: 'Həftə seç',
      monthSelect: 'Ay seç',
      yearSelect: 'il seç',
      decadeSelect: 'Onillik seçin',
      yearFormat: 'YYYY',
      dateFormat: 'D.M.YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D.M.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Əvvəlki ay (PageUp)',
      nextMonth: 'Növbəti ay (PageDown)',
      previousYear: 'Sonuncu il (Control + left)',
      nextYear: 'Növbəti il (Control + right)',
      previousDecade: 'Sonuncu onillik',
      nextDecade: 'Növbəti onillik',
      previousCentury: 'Sonuncu əsr',
      nextCentury: 'Növbəti əsr'
    },
    timePickerLocale: {
      placeholder: 'Vaxtı seç'
    }
  },
  TimePicker: {
    placeholder: 'Vaxtı seç'
  },
  Calendar: {
    lang: {
      placeholder: 'Tarix seçin',
      rangePlaceholder: ['Başlama tarixi', 'Bitmə tarixi'],
      locale: 'az_AZ',
      today: 'Bugün',
      now: 'İndi',
      backToToday: 'Bugünə qayıt',
      ok: 'Təsdiq',
      clear: 'Təmizlə',
      month: 'Ay',
      year: 'İl',
      timeSelect: 'vaxtı seç',
      dateSelect: 'tarixi seç',
      weekSelect: 'Həftə seç',
      monthSelect: 'Ay seç',
      yearSelect: 'il seç',
      decadeSelect: 'Onillik seçin',
      yearFormat: 'YYYY',
      dateFormat: 'D.M.YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D.M.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Əvvəlki ay (PageUp)',
      nextMonth: 'Növbəti ay (PageDown)',
      previousYear: 'Sonuncu il (Control + left)',
      nextYear: 'Növbəti il (Control + right)',
      previousDecade: 'Sonuncu onillik',
      nextDecade: 'Növbəti onillik',
      previousCentury: 'Sonuncu əsr',
      nextCentury: 'Növbəti əsr'
    },
    timePickerLocale: {
      placeholder: 'Vaxtı seç'
    }
  },
  Table: {
    filterTitle: 'Filter menyu',
    filterConfirm: 'Axtar',
    filterReset: 'Sıfırla',
    emptyText: 'Məlumat yoxdur',
    selectAll: 'Cari səhifəni seç',
    selectInvert: 'Invert current page'
  },
  Modal: {
    okText: 'Bəli',
    cancelText: 'Ləğv et',
    justOkText: 'Bəli'
  },
  Popconfirm: {
    okText: 'Bəli',
    cancelText: 'Ləğv et'
  },
  Transfer: {
    titles: ['', ''],
    notFoundContent: 'Tapılmadı',
    searchPlaceholder: 'Burada axtar',
    itemUnit: 'item',
    itemsUnit: 'items'
  },
  Select: {
    notFoundContent: 'Tapılmadı'
  },
  Upload: {
    uploading: 'Yüklənir...',
    removeFile: 'Faylı sil',
    uploadError: 'Yükləmə xətası',
    previewFile: 'Fayla önbaxış'
  }
};
